// Node.DOCUMENT_POSITION_FOLLOWING; set for descendants and for portals appended after the slide-over.
const DOCUMENT_POSITION_FOLLOWING = 4;

export interface DocumentNodeLike {
    compareDocumentPosition(other: DocumentNodeLike): number;
}

// A modal inside the slide-over or portalled after it is on top, so it owns Escape.
export function hasModalStackedOver(
    slideOver: DocumentNodeLike,
    openModals: Iterable<DocumentNodeLike>
): boolean {
    return Array.from(openModals).some(
        (modal) =>
            modal !== slideOver &&
            (slideOver.compareDocumentPosition(modal) & DOCUMENT_POSITION_FOLLOWING) !== 0
    );
}
